// src/errorGuards.js
export function installGlobalErrorGuards() {
  if (typeof window === "undefined") return;

  // Helper to detect Ably channel lifecycle errors
  const isAblyLifecycleError = (errOrReason) => {
    if (!errOrReason) return false;
    
    const msg = String(errOrReason.message || errOrReason || "").toLowerCase();
    
    // Check for Ably error codes (90001 = channel detached)
    if (errOrReason.code === 90001 || errOrReason.statusCode === 90001) {
      return true;
    }
    
    // Check for Ably error messages
    return (
      msg.includes("detach request superseded") ||
      msg.includes("attach request superseded") ||
      msg.includes("subsequent attach request") ||
      msg.includes("channel detached") ||
      msg.includes("channel is detached") ||
      msg.includes("channel has detached") ||
      msg.includes("connection to server unavailable") ||
      msg.includes("channel failed") ||
      msg.includes("channel suspended") ||
      msg.includes("errorinfo") // Ably's ErrorInfo class
    );
  };

  // Catch synchronous errors that bubble to window
  window.addEventListener("error", (event) => {
    try {
      if (isAblyLifecycleError(event.error)) {
        console.warn(
          "[ABLY-GUARD] Suppressed global Ably lifecycle error:",
          event.error?.message || event.message || event.error
        );
        event.preventDefault(); // tell browser "we handled it"
        event.stopPropagation(); // prevent further propagation
        event.stopImmediatePropagation(); // stop ALL handlers
        return false; // extra prevention
      }

      // Let all other errors behave normally
    } catch (e) {
      // If our guard fails, don't break anything
      console.error("[ABLY-GUARD] Error in global error handler:", e);
    }
  }, true); // Use capture phase to intercept early

  // Catch unhandled Promise rejections just in case Ably uses them
  window.addEventListener("unhandledrejection", (event) => {
    try {
      if (isAblyLifecycleError(event.reason)) {
        console.warn(
          "[ABLY-GUARD] Suppressed unhandledrejection Ably error:",
          event.reason?.message || event.reason
        );
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        return false;
      }
    } catch (e) {
      console.error("[ABLY-GUARD] Error in unhandledrejection handler:", e);
    }
  }, true); // Use capture phase

  console.log("✅ [ABLY-GUARD] Global error guards installed");
}
